<h2 mat-dialog-title>
  {{ 'TERMS_OF_SERVICE.TERMS_OF_SERVICE_AGREEMENT' | translate }}
</h2>
<mat-dialog-content>
  <div
    class="tos-content"
    [innerHTML]="tos | iTrustThisHtml"
    *ngIf="(unifiedTermsOfServiceData$ | async)?.data?.unifiedTermsOfService as tos"
  ></div>
</mat-dialog-content>
<mat-dialog-actions>
  <button
    *ngIf="!tosService.isImpersonated"
    mat-raised-button
    color="primary"
    [disabled]="submitting"
    (click)="acceptTermsOfService()"
  >
    {{ 'TERMS_OF_SERVICE.ACCEPT' | translate }}
  </button>
  <button mat-button color="primary" (click)="closeDialog(false)">
    {{ cancelText | translate }}
  </button>
</mat-dialog-actions>
